import { render } from "./orderHistory.vue?vue&type=template&id=19222e18&scoped=true&ts=true"
import script from "./orderHistory.vue?vue&type=script&lang=ts"
export * from "./orderHistory.vue?vue&type=script&lang=ts"

import "./orderHistory.vue?vue&type=style&index=0&id=19222e18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19222e18"],['__file',"src/components/account/orderHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19222e18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19222e18', __exports__)) {
    api.reload('19222e18', __exports__)
  }
  
  module.hot.accept("./orderHistory.vue?vue&type=template&id=19222e18&scoped=true&ts=true", () => {
    api.rerender('19222e18', render)
  })

}


export default __exports__